"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessToken = void 0;
/**
 * AccessToken contains necessary information about a token.
 */
var AccessToken = /** @class */ (function () {
    function AccessToken(token, expiresAt, scope, payload) {
        this.token = token;
        this.expiresAt = expiresAt;
        this.scope = scope;
        this.payload = payload;
    }
    return AccessToken;
}());
exports.AccessToken = AccessToken;
